import positiveLogo from '../assets/logos/positive/logo.svg?raw';

/** One SVG: text inherits its color; chevrons keep the brand orange. */
export function createPositiveLogo(ownerDocument) {
  const template = ownerDocument.createElement('template');
  template.innerHTML = positiveLogo;
  const logo = template.content.firstElementChild;
  logo.classList.add('positive-nav-brand-logo');
  logo.setAttribute('aria-hidden', 'true');
  logo.setAttribute('focusable', 'false');
  for (const chevron of logo.querySelectorAll('path[fill="#ff5b49"]')) {
    chevron.classList.add('positive-nav-brand-chevron');
  }
  return logo;
}
